// extracted by mini-css-extract-plugin
module.exports = {"singleSocial":"SingleSocial_singleSocial__mRrzc"};